import { useContext, useEffect, useState, FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import Auth from 'store/auth'
import WebinarSocketContext from 'context/webinarSocketContext'
import ChatInput from './chat-input'
import useNMO from 'store/analytics-nmo/useNMO'

import { cutHashFromURL, getDigitFromString } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'
import { StatusVocabulary } from 'constants/data'
import { buttonIdWebinarEnded } from 'constants/clickableElementsId'
import { PLACEFLAG_CHAT } from 'constants/analytic-data'
import { GapMessage } from '../../player/data'
import { webinarsForStudents } from 'components/students/students-data'
import { IChatMessage } from 'constants/types/webinar.types'

import styles from './chat-bottom.module.scss'

interface IChatBottom {
  msgReplyTo: IChatMessage | null
  handleCancelReply: () => void
}

const ChatBottom: FC<IChatBottom> = ({ msgReplyTo, handleCancelReply }: IChatBottom) => {
  const { webinarStatus, handleWebSocketSend, isBlocked } = useContext(WebinarSocketContext)
  const { isAuthorized, isFilledUser, isSponsor } = Auth.useAuth()
  const router = useRouter()
  const materialId = Number(getDigitFromString(router.query.id as string))
  const isChatForStudent = webinarsForStudents.includes(materialId)

  const { setSource } = useNMO()
  const [gapText, setGapText] = useState('')

  const handleAnalyticSource = () => setSource(PLACEFLAG_CHAT)

  const path = cutHashFromURL(router.asPath)
  const isHourBefore = webinarStatus === StatusVocabulary.HOUR_BEFORE
  const isEnded = webinarStatus === StatusVocabulary.PAST

  useEffect(() => {
    let message = ''
    if (!isAuthorized) message = GapMessage.NOT_AUTHORIZED
    else if (isBlocked) message = GapMessage.BLOCKED
    else if (!isFilledUser && !isSponsor && !isChatForStudent) message = GapMessage.NOT_FILLED
    else if (isHourBefore) message = GapMessage.HOUR_BEFORE
    else if (isEnded) message = GapMessage.ENDED

    setGapText(message)
  }, [isAuthorized, isFilledUser, isSponsor, isBlocked, isHourBefore, isEnded, isChatForStudent])

  return (
    <>
      {!gapText ? (
        <ChatInput
          handleWebSocketSend={handleWebSocketSend}
          msgReplyTo={msgReplyTo}
          handleCancelReply={handleCancelReply}
        />
      ) : (
        <div
          className={clsx(styles.chatInputBlock, styles.chatInputUnauth, {
            [styles.isNotFilled]: !isAuthorized || (isAuthorized && !isFilledUser),
          })}
          id={isEnded ? buttonIdWebinarEnded : ''}
        >
          {gapText}
          {isAuthorized && !isFilledUser && (
            <Link
              href={`${path}#${popupName.anketaWebinar}`}
              className={styles.link}
              onClick={handleAnalyticSource}
            >
              Заполнить
            </Link>
          )}
        </div>
      )}
    </>
  )
}

export default ChatBottom
